import styled from 'styled-components';

export const FooterSection = styled.footer`
  position: relative;
  z-index: 9;
  background-color: #11111c;
  padding: 110px 0 70px;

  @media only screen and (max-width: 767px) {
    padding: 40px 0;
  }

  h4 {
    color: ${({ theme: { colors } }) => colors.white};
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.13px;
    line-height: 25px;
    margin-bottom: 30px;
  }

  .about {
    opacity: 0.6;
    color: ${({ theme: { colors } }) => colors.white};
    font-size: 14px;
    line-height: 22px;
    margin-top: 30px;
    margin-bottom: 40px;
  }

  .social a {
    color: ${({ theme: { colors } }) => colors.white};
    opacity: 0.4;
    font-size: 22px;
    margin-right: 40px;

    &:hover {
      opacity: 1;
    }

    @media only screen and (max-width: 767px) {
      opacity: 1;
    }
  }

  @media only screen and (max-width: 767px) {
    .atc-logo {
      display: none;
    }

    .footer-links-area {
      text-align: center;
      padding: 10px 0;
    }
  }
`;

export const FooterMenuList = styled.ul`
  li {
    list-style-type: none;
    margin-bottom: 20px;

    a {
      opacity: 0.6;
      color: ${({ theme: { colors } }) => colors.white};
      font-size: 16px;

      &:hover {
        opacity: 1;
      }
    }
  }
`;

export const FooterCopyright = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 36px;
  padding-top: 35px;

  .list p {
    opacity: 0.6;
    color: ${({ theme: { colors } }) => colors.white};
    font-size: 14px;
    line-height: 22px;
    padding-left: 15px;
    position: relative;
    margin-bottom: 29px;

    &:before {
      content: attr(data-num);
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .copyright {
    opacity: 0.6;
    color: ${({ theme: { colors } }) => colors.white};
    font-size: 14px;
    line-height: 22px;
    position: relative;
    margin: 0;
  }
`;
